/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import PieChartPageSection from '../../../components/Charts/PieChartPageSection/PieChartPageSection';
import ControlledWidthContainer from '../../../components/Community/Sections/ControlledWidthContainer/ControlledWidthContainer';
import SingleReviewComponent, {
    MULTIPLE_REVIEW,
} from '../../../components/Community/SingleReviewComponent/SingleReviewComponent';
import CompanyPageLayout from '../../../components/CompanyPages/CompanyPageLayout/CompanyPageLayout';
import ArticleGrid from '../../../components/CompanyPages/Sections/ArticleGrid/ArticleGrid';
import BadgeDisplayGridSection from '../../../components/CompanyPages/Sections/BadgeDisplayGridSection/BadgeDisplayGridSection';
import EmployerNotClaimedBox from '../../../components/CompanyPages/Sections/EmployerNotClaimedBox/EmployerNotClaimedBox';
import EmployerPageJobCallToAction from '../../../components/CompanyPages/Sections/EmployerPageJobCallToAction/EmployerPageJobCallToAction';
import FgbFeaturedEmployeeSlide from '../../../components/CompanyPages/Sections/FgbFeaturedEmployeeSlide/FgbFeaturedEmployeeSlide';
import VideoPlayer from '../../../components/CompanyPages/Sections/VideoPlayer/VideoPlayer';
import FGBLabel from '../../../components/Elements/FGBLabel/FGBLabel';
import NextArrow from '../../../components/Icons/NextArrow/NextArrow';
import PrevArrow from '../../../components/Icons/PrevArrow/PrevArrow';
import { ARTICLES_CARD_PROPTYPES2 } from '../../../components/Includes/ArticleCardProps';
import {
    COMPANY_BADGE_TYPES_PROP,
    COMPANY_DEFAULT_PROPS,
    COMPANY_PROPTYPES,
    EMPLOYEE_PROPTYPES,
    GENDER_DIVERSITY_PROPTYPES,
} from '../../../components/Includes/CompanyProps';
import { JOB_PROPTYPES } from '../../../components/Includes/JobProps';
import { SINGLE_REVIEW_PROPTYPES } from '../../../components/Includes/SingleReviewProps';
import Button from '../../../components/Input/Button/Button';
import { buildImagePath } from '../../../components/JobComponents/Company/Image/logo';
import Slider from '../../../components/JobComponents/Silder/Slider';
import JobListing from '../../../components/JobV3/Elements/JobListing/JobListing';
import ControlledWidthContainerEightHundred from '../../../components/Layout/ControlledWidthContainerEightHundred/ControlledWidthContainerEightHundred';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
    PAGE_TABS,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import { ATTRIBUTION_MODE_CHERRYPICK } from '../../../contexts/AbstractContext';
import { JobContextProvider } from '../../../contexts/JobContext';
import { videoTypes } from '../../../utilities/ui_utilities';

import './CompanyOverview.scss';

export const CONVERT_CONTENT = (content) => {
    return { __html: content };
};

export default class CompanyOverview extends React.PureComponent {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    renderSponsoredCompanyDescription = () => {
        return this.props.companyCulture ? (
            <div className="sponsored-company-description">
                <div className="sponsored-company-title section-title">{`Why women love working at ${this.props.company.companyName}`}</div>
                <div
                    className="what-you-need-to-know-section-description"
                    dangerouslySetInnerHTML={CONVERT_CONTENT(
                        this.props.companyCulture
                    )}
                />
            </div>
        ) : null;
    };

    badgeDisplayGridSection = () => {
        const mainContent = this.props.company.isSponsor ? (
            this.renderSponsoredCompanyDescription()
        ) : (
            <EmployerNotClaimedBox company={this.props.company} />
        );
        return (
            <BadgeDisplayGridSection companyBadges={this.props.companyBadges}>
                {mainContent}
            </BadgeDisplayGridSection>
        );
    };

    womensJobReviewsChartSection = () => {
        return this.props.womenJobReviews &&
            this.props.womenJobReviews.length ? (
            <ControlledWidthContainerEightHundred className="women-job-reviews-section">
                <PieChartPageSection
                    chartProps={this.props.womenJobReviews}
                    sectionTitle={"FGB'ers' job reviews"}
                />
            </ControlledWidthContainerEightHundred>
        ) : null;
    };

    companyArticlesSection = () => {
        const title = `Read more about ${this.props.company.companyName}`;
        return this.props.companyArticles &&
            this.props.companyArticles.length ? (
            <ArticleGrid content={this.props.companyArticles} title={title} />
        ) : null;
    };

    companyReviewsSection = () => {
        return this.props.companyReviews && this.props.companyReviews.length ? (
            <ControlledWidthContainerEightHundred className="company-reviews-section">
                <div className="section-title">Highlighted reviews</div>
                <ControlledWidthContainer>
                    {this.props.companyReviews
                        ? this.props.companyReviews.map((review) => (
                              <SingleReviewComponent
                                  key={review.id}
                                  {...review}
                                  company={this.props.company}
                                  location={MULTIPLE_REVIEW}
                              />
                          ))
                        : null}
                    <div className="see-all-reviews-button">
                        <a
                            href={`/company-reviews/${this.props.company.companyUrl}`}
                        >
                            <Button type="solid" value="See all reviews" />
                        </a>
                    </div>
                </ControlledWidthContainer>
            </ControlledWidthContainerEightHundred>
        ) : null;
    };

    renderEmployerJobCallToAction = () => {
        if (this.props.company.employerInfo.jobCount === 0) {
            return;
        }

        const props = {
            title: `${this.props.company.companyName} is hiring`,
            description: this.props.bannerText,
            jobCount: this.props.company.employerInfo.jobCount,
            button: {
                url: `/company/jobs/${this.props.company.companyUrl}`,
                text: `See all jobs`,
            },
        };
        return (
            <ControlledWidthContainerEightHundred>
                <EmployerPageJobCallToAction {...props} />
            </ControlledWidthContainerEightHundred>
        );
    };

    renderFeaturedJobsSection = () => {
        const { jobs, company } = this.props;

        return jobs && jobs.length ? (
            <ControlledWidthContainerEightHundred className="featured-job-section">
                <div className="section-title featured-job-title">{`New Jobs at ${company.companyName}`}</div>
                <ControlledWidthContainer>
                    {jobs.map((j) => (
                        <JobListing key={j.hash} {...j} showExpired={false} />
                    ))}
                    <div className="see-all-jobs-button">
                        <a href={`/company/jobs/${company.companyUrl}`}>
                            <Button type="solid" value="See all jobs" />
                        </a>
                    </div>
                </ControlledWidthContainer>
            </ControlledWidthContainerEightHundred>
        ) : null;
    };

    renderSponsoredCompanyVideo = () => {
        let videoComponent = null;
        if (this.props.companyVideo) {
            videoComponent = <VideoPlayer {...this.props.companyVideo} />;
        }
        return (
            <ControlledWidthContainer className="video-section">
                {videoComponent}
            </ControlledWidthContainer>
        );
    };

    sponsoredEmployerPictureSlider = () => {
        const sliderSettings = {
            dots: true,
            infinite: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            swipe: false,
            variableWidth: true,
            pauseOnHover: false,
        };

        return this.props.companySlides && this.props.companySlides.length ? (
            <div className="company-slider">
                <NoSSR>
                    <Slider settings={sliderSettings}>
                        {this.props.companySlides.map((slide) => {
                            const injectedTransform = {
                                default: 'c_scale,f_webp,q_100,h_800',
                            };
                            const imageSrc = buildImagePath(
                                slide.src,
                                'default',
                                injectedTransform
                            );
                            return (
                                <img
                                    key={slide.src}
                                    className="sponsored-company-slide-image"
                                    src={imageSrc}
                                    height={300}
                                    alt="sponsored company slide"
                                />
                            );
                        })}
                    </Slider>
                </NoSSR>
            </div>
        ) : null;
    };

    sponsoredWhatYouNeedToKNowSection = () => {
        return this.props.sponsoredCompanyDescription ? (
            <ControlledWidthContainerEightHundred className="what-you-need-to-know-section">
                <div className="section-title">What you need to know</div>
                <ControlledWidthContainer>
                    <div
                        className="sponsored-company-description"
                        dangerouslySetInnerHTML={CONVERT_CONTENT(
                            this.props.sponsoredCompanyDescription
                        )}
                    />
                </ControlledWidthContainer>
            </ControlledWidthContainerEightHundred>
        ) : null;
    };

    genderDiversityDescriptionSection = () => {
        return this.props.genderDiversity &&
            this.props.genderDiversity.description ? (
            <ControlledWidthContainerEightHundred className="what-you-need-to-know-section">
                <div className="section-title">Gender diversity</div>
                <ControlledWidthContainer>
                    <div
                        className="what-you-need-to-know-section-description"
                        dangerouslySetInnerHTML={CONVERT_CONTENT(
                            this.props.genderDiversity.description
                        )}
                    />
                </ControlledWidthContainer>
            </ControlledWidthContainerEightHundred>
        ) : null;
    };

    sponsoredGenderDataSection = () => {
        return this.props.genderDiversity &&
            this.props.genderDiversity.genderData &&
            (this.props.genderDiversity.genderData.womenStaff ||
                this.props.genderDiversity.genderData.womenSenior ||
                this.props.genderDiversity.genderData.womenDirector) ? (
            <ControlledWidthContainerEightHundred className="gender-data-section">
                <div className="section-title gender-data-title">
                    Gender data
                </div>
                <ControlledWidthContainer>
                    {this.props.genderDiversity.genderData.womenStaff ? (
                        <div className="section">
                            <FGBLabel>Women in workforce</FGBLabel>
                            <div className="number-display">{`${this.props.genderDiversity.genderData.womenStaff}%`}</div>
                        </div>
                    ) : null}
                    {this.props.genderDiversity.genderData.womenSenior ? (
                        <div className="section">
                            <FGBLabel>Women holding senior management</FGBLabel>
                            <div className="number-display">{`${this.props.genderDiversity.genderData.womenSenior}%`}</div>
                        </div>
                    ) : null}
                    {this.props.genderDiversity.genderData.womenDirector ? (
                        <div className="section">
                            <FGBLabel>Women Directors on board</FGBLabel>
                            <div className="number-display">{`${this.props.genderDiversity.genderData.womenDirector}%`}</div>
                        </div>
                    ) : null}
                </ControlledWidthContainer>
            </ControlledWidthContainerEightHundred>
        ) : null;
    };

    renderFeaturedEmployees = () => {
        const sliderSettings = {
            dots: this.props.employees && this.props.employees.length > 1,
            arrows: this.props.employees && this.props.employees.length > 1,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            adaptiveHeight: true,
            swipe: true,
            variableWidth: false,
            nextArrow:
                this.props.employees && this.props.employees.length > 1 ? (
                    <div>
                        <NextArrow onClick={this.next} />
                    </div>
                ) : null,
            prevArrow:
                this.props.employees && this.props.employees.length > 1 ? (
                    <div>
                        <PrevArrow onClick={this.previous} />
                    </div>
                ) : null,
        };

        return this.props.employees && this.props.employees.length ? (
            <div className="featuredEmployeeSection">
                <NoSSR>
                    <ControlledWidthContainerEightHundred>
                        <div className="section-title">{`Meet employees of ${this.props.company.companyName}`}</div>
                        <Slider
                            refs={(c) => {
                                this.slider = c;
                            }}
                            settings={sliderSettings}
                        >
                            {this.props.employees.map((employee) => (
                                <div key={employee.name}>
                                    <FgbFeaturedEmployeeSlide {...employee} />
                                </div>
                            ))}
                        </Slider>
                    </ControlledWidthContainerEightHundred>
                </NoSSR>
            </div>
        ) : null;
    };

    crowdsourcedBenefitsSection = () => {
        return this.props.crowdSourcedBenefitData &&
            this.props.crowdSourcedBenefitData.length ? (
            <ControlledWidthContainerEightHundred className="crowdsourced-benefits-section">
                <div className="section-title">
                    Crowdsourced Employer Benefits
                </div>
                <ControlledWidthContainer className="data-section-display">
                    <div className="description">
                        Data is based on user-submitted tips and may reflect
                        median or consensus figures.
                    </div>
                    <div className="leave-tip-button crowdsourced-section-button">
                        <a
                            href={`/company-benefits/${this.props.company.companyUrl}`}
                        >
                            <Button
                                type="secondary-blue-gray"
                                value="Work(ed) here? Leave a tip"
                            />
                        </a>
                    </div>
                    {this.props.crowdSourcedBenefitData.map((item) => {
                        const titles = {
                            vacation: 'vacation',
                            paid_maternity: 'paid maternity',
                            unpaid_maternity: 'unpaid maternity',
                            paid_paternity: 'paid paternity',
                            unpaid_paternity: 'unpaid paternity',
                        };
                        return (
                            <div className="data-section">
                                <FGBLabel>{titles[item.type]}</FGBLabel>
                                <div className={`benefit-section ${item.type}`}>
                                    {`${item.median} weeks`}
                                </div>
                            </div>
                        );
                    })}
                    <a
                        href={`/company-benefits/${this.props.company.companyUrl}`}
                    >
                        Flextime, Healthcare, On-Site Childcare, 401k and more
                        ...
                    </a>
                    <div className="see-benefits-button crowdsourced-section-button">
                        <a
                            href={`/company-benefits/${this.props.company.companyUrl}`}
                        >
                            <Button type="solid" value="See more benefits" />
                        </a>
                    </div>
                </ControlledWidthContainer>
            </ControlledWidthContainerEightHundred>
        ) : null;
    };

    twitterWidget = () => {
        return this.props.socialMediaAccounts &&
            this.props.socialMediaAccounts.twitter ? (
            <ControlledWidthContainerEightHundred className="social-media-section">
                <div className="section-title">{`Happening now at ${this.props.company.companyName}`}</div>
                <div className="social-media-display">
                    <a
                        className="twitter-timeline"
                        data-height="787"
                        href={`https://twitter.com/${this.props.socialMediaAccounts.twitter}?ref_src=twsrc%5Etfw`}
                    >
                        &nbsp;
                    </a>
                </div>
            </ControlledWidthContainerEightHundred>
        ) : null;
    };

    sponsoredContent = () => {
        return (
            <React.Fragment>
                {this.badgeDisplayGridSection()}
                {this.sponsoredEmployerPictureSlider()}
                {this.renderFeaturedJobsSection()}
                {this.companyArticlesSection()}
                {this.renderFeaturedEmployees()}
                {this.renderSponsoredCompanyVideo()}
                {this.sponsoredWhatYouNeedToKNowSection()}
                {this.genderDiversityDescriptionSection()}
                {this.sponsoredGenderDataSection()}
                {this.twitterWidget()}
                {this.companyReviewsSection()}
                {this.womensJobReviewsChartSection()}
                {this.renderEmployerJobCallToAction()}
            </React.Fragment>
        );
    };

    nonSponsoredContent = () => {
        return (
            <React.Fragment>
                {this.womensJobReviewsChartSection()}
                {this.badgeDisplayGridSection()}
                {this.companyReviewsSection()}
                {this.crowdsourcedBenefitsSection()}
            </React.Fragment>
        );
    };

    next() {
        this.slider.slickNext();
    }

    previous() {
        this.slider.slickPrev();
    }

    render() {
        return (
            <div className="page-CompanyPages-CompanyOverview">
                <SnowplowPageViewTracker
                    pageCompanyId={this.props.company.companyId}
                    pageEntityId={this.props.company.companyId}
                    pageSection={PAGE_VIEW_SECTIONS.COMPANY_PROFILE}
                    pageTab={PAGE_TABS.COMPANY_OVERVIEW}
                    pageType={PAGE_VIEW_TYPES.CONTENT}
                />
                <JobContextProvider
                    {...this.props}
                    attributionMode={ATTRIBUTION_MODE_CHERRYPICK}
                    content={this.props.jobs}
                    userJobProfile={this.props.userJobProfile}
                >
                    <CompanyPageLayout
                        topics={this.props.topics}
                        company={this.props.company}
                    >
                        {this.props.company.isSponsor
                            ? this.sponsoredContent()
                            : this.nonSponsoredContent()}
                    </CompanyPageLayout>
                </JobContextProvider>
            </div>
        );
    }
}

CompanyOverview.propTypes = {
    company: PropTypes.shape(COMPANY_PROPTYPES),
    sponsoredCompanyDescription: PropTypes.string,
    companyBadges: PropTypes.arrayOf(
        PropTypes.shape({
            type: COMPANY_BADGE_TYPES_PROP,
            url: PropTypes.string,
        })
    ),
    companyCulture: PropTypes.string,
    companySlides: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        })
    ),
    jobs: PropTypes.arrayOf(PropTypes.shape(JOB_PROPTYPES)),
    companyArticles: PropTypes.arrayOf(
        PropTypes.shape(ARTICLES_CARD_PROPTYPES2)
    ),
    employees: PropTypes.arrayOf(PropTypes.shape(EMPLOYEE_PROPTYPES)),
    companyVideo: PropTypes.shape({
        videoSrc: PropTypes.string,
        videoType: PropTypes.oneOf([videoTypes.CLOUDINARY, videoTypes.YOUTUBE]),
    }),
    genderDiversity: PropTypes.shape(GENDER_DIVERSITY_PROPTYPES),
    socialMediaAccounts: PropTypes.shape({
        twitter: PropTypes.string,
        instagram: PropTypes.string,
    }),
    companyReviews: PropTypes.arrayOf(PropTypes.shape(SINGLE_REVIEW_PROPTYPES)),
    womenJobReviews: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string,
                    value: PropTypes.number,
                })
            ),
            chartDescription: PropTypes.string,
        })
    ),
    crowdSourcedBenefitData: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            median: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ),
    topics: PropTypes.arrayOf(PropTypes.shape()),
    userJobProfile: PropTypes.shape(),
    bannerText: PropTypes.string,
};

CompanyOverview.defaultProps = {
    ...COMPANY_DEFAULT_PROPS,
    bannerText: null,
    userJobProfile: null,
};
